export default () => ({
  profile: {},
  photoURL: undefined,
  liteProfile: {}
})
